module.exports = __webpack_public_path__ + "img/THE-BLOC-01.e675454e.jpg";